import { ResourceFilters } from './interfaces/ResourceFilters';

export class ODataQueryBuilder {
  // #region Class properties
  private readonly filters!: ResourceFilters;
  private initialPrefix!: InitialPrefix;
  private query = '';
  // #endregion

  constructor(filters: ResourceFilters) {
    this.filters = filters;
  }

  // #region public methods
  public getQuery(initialPrefix: InitialPrefix): string {
    this.initialPrefix = initialPrefix;

    this.resolveContains();
    this.resolveIsEqual();
    this.resolveIsNotEqual();
    this.resolveHasAnyWhere();
    this.resolveIsLessThan();
    this.resolveIsGreaterThan();
    this.resolveOr();
    this.resolveIsAny();
    this.resolveCustom();
    return this.query;
  }
  // #endregion

  // #region resolvers
  private resolveContains(): void {
    if (!this.filters.contains) {
      return;
    }
    Object.entries(this.filters.contains).forEach(([key, value]) => {
      this.query += `${this.concatenationValue}contains(${key}, '${value}')`;
    });
  }

  private resolveIsEqual(): void {
    if (!this.filters.isEqual) {
      return;
    }
    Object.entries(this.filters.isEqual).forEach(([key, value]) => {
      this.query += `${this.concatenationValue}${key} eq ${value}`;
    });
  }

  private resolveIsNotEqual(): void {
    if (!this.filters.isNotEqual) {
      return;
    }
    Object.entries(this.filters.isNotEqual).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item: string | number) => {
          this.query += `${this.concatenationValue}${key} ne ${item}`;
        });
        return;
      }

      this.query += `${this.concatenationValue}${key} ne ${value}`;
    });
  }

  private resolveIsLessThan(): void {
    if (!this.filters.isLessThan) {
      return;
    }
    Object.entries(this.filters.isLessThan).forEach(([key, value]) => {
      this.query += `${this.concatenationValue}(${key} le ${value})`;
    });
  }

  private resolveIsGreaterThan(): void {
    if (!this.filters.isGreaterThan) {
      return;
    }
    Object.entries(this.filters.isGreaterThan).forEach(([key, value]) => {
      this.query += `${this.concatenationValue}(${key} le ${value}) eq false`;
    });
  }

  private resolveHasAnyWhere(): void {
    if (!this.filters.hasAnyWhere) {
      return;
    }
    Object.entries(this.filters.hasAnyWhere).forEach(([key, value]) => {
      const properties = Object.keys(value);
      properties.forEach((property) => {
        this.query += `${this.concatenationValue}${key}/any(e: e/${property} eq ${value[property]})`;
      });
    });
  }
  private resolveOr(): void {
    if (!this.filters.or || this.filters.or.length === 0) {
      return;
    }
    var queryTmp = '';
    this.filters.or.forEach((property) => {
      Object.entries(property).map(([key, value]) => {
        queryTmp += ` or ${key} eq ${value}`;
      });
    });
    queryTmp = queryTmp.substring(4);
    this.query += `${this.concatenationValue}(${queryTmp})`;
  }

  private resolveIsAny(): void {
    if (!this.filters.isAny || this.filters.isAny.length === 0) {
      return;
    }
    Object.entries(this.filters.isAny).forEach(([key, value]) => {
      if (value === "") return;

      const segments = key.split("/");
      let filter = segments.pop();
      this.query += `${this.concatenationValue}${segments.join("/")}/any(x: x/${filter} eq ${value})`;
    });
  }

  private resolveCustom(): void {
    if (this.filters.custom === '') {
      return;
    }
    this.query += this.concatenationValue + this.filters.custom;
  }
  // #endregion

  // #region getters
  private get concatenationValue(): ConcatenationValue {
    return this.query.length ? ' and ' : `${this.initialPrefix}filter=`;
  }
  // #endregion
}

// #region Types
export type InitialPrefix = '?' | '&';
export type ConcatenationValue = ' and ' | '&filter=' | '?filter=';
// #endregion
